<template>
    <div>
        <upload-experimental-dataset-component @saveFile="handleSaveFile" :currentExperimentalDataset="currentExperimentalDataset" :assesmentMethods="assesmentMethods" :currentValidationPlanTemplate="currentValidationPlanTemplate" :currentExperimentalPlan="currentExperimentalPlan" @viewData="handleViewData" :currentMethod="currentMethod" @saveChromatogram="handleSaveChromatogram"  :validationParameters="validationParameters"></upload-experimental-dataset-component>
    </div>
</template>


<script>
import UploadExperimentalDatasetComponent from '@/components/dataset/UploadExperimentalDatasetComponent'
import AssessmentMethodOrder from "@/valchrom/AssessmentMethodOrder";
import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment';

export default {
    name: "UploadExperimentalDataset",
    components: {UploadExperimentalDatasetComponent},
    data: function () {
        return {
            component_url: 'experiments/datasets/',
            currentExperimentalDataset:{},
            currentExperimentalPlan: {},
            currentValidationPlanTemplate: {},
            assesmentMethods:[],
            currentMethod: {},
        }
    },
    mounted: function() {
        this.setBreadcrumb()

        if (this.$route.params.id) {
            this.currentExperimentalDataset.id = this.$route.params.id;        
        }
        else {
            console.log("ExperimentalDataset view no router params.id")
            this.currentExperimentalDataset.id = this.currentExperimentalDatasetID    
        }        
        this.getExperimentalDataset()
        //set ExperimentalDataset id in vuex
        this.setExperimentalDatasetId()
    },

    computed: {
        ...mapGetters ([
            'base_url', 'currentExperimentalDatasetID', 'auth_header',
            'validationParameters', 'mathservice_start_date'
        ])
    },

    methods: {
        ...mapMutations([
            'SET_BREADCRUMB', 'CHANGE_EXPERIMENTAL_DATASET_ID', 'CHANGE_OVERVIEW_OBJECT', 'CHANGE_ASSESSMENT_METHOD_OBJECT'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        //set global ExperimentalDatasetId
        setExperimentalDatasetId: function(){
            this.CHANGE_EXPERIMENTAL_DATASET_ID(this.currentExperimentalDataset.id)
        },
        getExperimentalDataset: function(){
            axios
                .get(
                    this.base_url+this.component_url +
                    this.currentExperimentalDataset.id,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    this.currentExperimentalDataset = response.data;
                    let createdMoment = moment(this.currentExperimentalDataset.created_at);
                    let isNew = createdMoment.isAfter(moment(this.mathservice_start_date));
                    if(isNew){
                        console.log("is new, redirecting");
                        this.$router.replace({ name: "ViewDataset", params: {id: this.currentExperimentalDataset.id} });
                    } else {
                        console.log("this.currentExperimentalDataset not new", this.currentExperimentalDataset)
                        this.currentExperimentalPlan.id = response.data.experimental_plan.id
                        this.getExperimentalPlan()
                    }
                })
                .catch(error => {
                    console.log("Something went wrong getting the current Experimental Plan in Dataset", error.response.data);
                });
        },
        getExperimentalPlan: function(){ 
            axios
                .get(
                    this.base_url+ 'experiments/plans/' +
                    this.currentExperimentalPlan.id,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    this.currentExperimentalPlan = response.data;     
                    console.log("this.currentExperimentalPlan", this.currentExperimentalPlan)
                    this.getValidationPlanTemplate()
                    this.getMethod()
                })
                .catch(error => {
                    console.log("Something went wrong getting the current Experimental Plan in Dataset", error.response.data);
                });
        },
        getValidationPlanTemplate: function(){ 
            axios
                .get(
                    this.base_url+ 'experiments/templates/' +this.currentExperimentalPlan.template.id,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    this.currentValidationPlanTemplate = response.data;
                    console.log("this.currentValidationPlanTemplate", this.currentValidationPlanTemplate)               
                    var mainThis = this                    
                    response.data.ams.forEach(function(method) {
                        mainThis.handleAMData(method)
                    })
                    
                })
                .catch(error => {
                    console.log("Something went wrong getting the current ValidationPlanTemplate", error.response.data);
                });
                
        },
        getMethod: function(){ 
            axios
                .get(
                    this.base_url+ 'experiments/methods/' +
                    this.currentExperimentalPlan.method.id,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    this.currentMethod = response.data;
                    console.log("this.currentMethod",this.currentMethod)
                })
                .catch(error => {
                    console.log("Something went wrong getting the current method", error);
                });
        },
        getAssesmentMethod: function(method, currentValidationPlanTemplate){
            axios
                .get(
                    this.base_url+ "experiments/assessments/"  +
                    method,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    var meth = response.data
                    this.handleAMData(meth)
                })
                .catch(error => {
                    console.log("Something went wrong getting the current ass meth", error);
                });
        },
        handleAMData(meth){
            meth.criteria = []
            // loop criteria and add to the method
            this.currentValidationPlanTemplate.criteria.forEach(function(item) {
                if(item.assessment_method==meth.id){
                    meth.criteria.push(item)
                }
            })
            // Add assMeth to the array
            this.assesmentMethods.push(meth)
            //sort assesment method array
            let sorter = (am1,am2)=>{
                return AssessmentMethodOrder.indexOf(am1.code_name) -
                    AssessmentMethodOrder.indexOf(am2.code_name)
            }
            this.assesmentMethods.sort(sorter);
        },
        handleViewData: function(assesmentMethodId){
            var viewDataObject = {
                assesment_method_id: assesmentMethodId,
                experimental_dataset_id: this.currentExperimentalDataset.id,
                from: 'upload-experimental-dataset-component'
            }
            this.$router.push({ name: "ViewExperimentalData", params: { obj: viewDataObject } });
        },
        handleSaveChromatogram: function(filesAndAssesmentMethodsobject){
            // console.log("Chromatogram ", filesAndAssesmentMethodsobject.files)           
            console.log("assesmentMethod ", filesAndAssesmentMethodsobject.assesmentMethod)          
            console.log("analyte ", filesAndAssesmentMethodsobject.analyte)
            var base64StringArray = []
            var mainThis = this

            filesAndAssesmentMethodsobject.files.forEach(function(file) {
                var reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => {
                    var base64Str = reader.result
                    var indexOfComma = base64Str.indexOf(',');
                    base64StringArray.push(base64Str.slice(indexOfComma+1))

                    var indexOfSemiColon = base64Str.indexOf(';');
                    var indexOfSlash = base64Str.indexOf('/');

                    if(base64StringArray.length == Object.entries(filesAndAssesmentMethodsobject.files).length){
                        var requestData = {}
                        if(filesAndAssesmentMethodsobject.analyte == 'NA'){
                            requestData = {
                                analyte: null,
                                data: base64StringArray,
                                file_type: base64Str.substring(indexOfSlash+1,indexOfSemiColon)
                            }
                        } else {
                            requestData = {
                                analyte: filesAndAssesmentMethodsobject.analyte.id,
                                data: base64StringArray,
                                file_type: base64Str.substring(indexOfSlash+1,indexOfSemiColon)
                            }
                        }
                        console.log("requestData: ", requestData) 
                        axios
                            .post(
                                mainThis.base_url+mainThis.component_url +
                                mainThis.currentExperimentalDataset.id+'/assessments/'+filesAndAssesmentMethodsobject.assesmentMethod.id+'/input/', requestData,
                                { 
                                    headers: mainThis.auth_header
                                }
                            )
                            .then(response => {
                                mainThis.loading = false;
                                mainThis.$toast.open({
                                    duration: 5000,
                                    message: `Assessment method data successfully uploaded`,
                                    position: 'is-top',
                                    type: 'is-primary'
                                })  
                                // clear overview data from store
                                mainThis.setOverviewObject()
                                mainThis.setAssessmentMethodObject()      
                                
                                mainThis.handleViewData(filesAndAssesmentMethodsobject.assesmentMethod.id)
                                console.log("Assessment method data successfully uploaded", response);
                            })
                            .catch(error => {
                                mainThis.loading = false;
                                mainThis.$toast.open({
                                    duration: 5000,
                                    message: `Assessment method data not successfully uploaded`,
                                    position: 'is-top',
                                    type: 'is-danger'
                                })
                                this.dataCheckErrors = error.response.data
                                console.log("Assessment method data not successfully uploaded", error.response.data);
                            });
                    }
                }
            })
        },
        handleSaveFile: function(filesAndAssesmentMethodsobject){
            console.log("handleSavefile", filesAndAssesmentMethodsobject)
            // var base64File=''
            var reader = new FileReader()
            reader.readAsDataURL(filesAndAssesmentMethodsobject.file)
            reader.onload = () => {
                var base64Str = reader.result
                var indexOfComma = base64Str.indexOf(',');
                var indexOfSemiColon = base64Str.indexOf(';');
                var indexOfSlash = base64Str.indexOf('/');

                var requestData = {
                    analyte: null,
                    data: [base64Str.slice(indexOfComma+1)],
                    file_type: base64Str.substring(indexOfSlash+1,indexOfSemiColon)
                }

                console.log("requestData: ", requestData)  

                axios
                    .head(this.base_url+ this.component_url + this.currentExperimentalDataset.id + '/assessments/' + filesAndAssesmentMethodsobject.assesmentMethod.id + '/input/',
                    {
                        headers: this.auth_header
                    })
                    .then((response) => {
                        // check if there is Data
                        if(response.headers['content-length']==2){
                           this.sendExperimentalDataset(filesAndAssesmentMethodsobject, requestData)
                        } 
                        else if (response.headers['content-length']>2) {                        
                            this.$dialog.confirm({
                                title: 'Overwriting data',
                                message: 'Are you sure you want to <b>overwrite</b> the existing data? This action cannot be undone.',
                                confirmText: 'Overwrite Data',
                                type: 'is-warning',
                                hasIcon: true,
                                onConfirm: () => this.sendExperimentalDataset(filesAndAssesmentMethodsobject, requestData)
                            })
                        }
                    })
                    .catch((error) => {
                        console.log('head request error: ', error)
                    }); 
            }
            reader.onerror = function (error) {
                console.log('Error converting to base64: ', error);
            }
        },

        sendExperimentalDataset(filesAndAssesmentMethodsobject, requestData){
            this.$toast.open({
                message: 'Upload has started!',
                type: 'is-info',
                position: 'is-top'
            }) 
            axios
                .post(
                    this.base_url+this.component_url +
                    this.currentExperimentalDataset.id+'/assessments/'+filesAndAssesmentMethodsobject.assesmentMethod.id+'/input/', requestData,
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Assessment method data successfully uploaded`,
                        position: 'is-top',
                        type: 'is-primary'
                    })  
                    // clear overview data from store
                    this.setOverviewObject()
                    this.setAssessmentMethodObject()
                    this.handleViewData(filesAndAssesmentMethodsobject.assesmentMethod.id)
                    console.log("Assessment method data successfully uploaded", response);
                })
                .catch(error => {
                    this.loading = false;
                    this.$dialog.confirm({
                        title: 'Data format error',
                        message: `${error.response.data.map(error => `<span> ${error}</span>`)}. Correct the dataset and re-upload it`,
                        type: 'is-danger',
                        hasIcon: true
                    })
                    console.log("Assessment method data not successfully uploaded", error.response.data);
                });
        },
        
        setOverviewObject: function(){
            this.CHANGE_OVERVIEW_OBJECT({})
        },
        setAssessmentMethodObject: function() {
            this.CHANGE_ASSESSMENT_METHOD_OBJECT({})
        },
    }
}
</script>
